import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { createTmOptions as Y } from "../../select/src/utils.js";
import Z from "./styles/index.cssr.js";
import { mapAutoCompleteOptionsToSelectOptions as ee } from "./utils.js";
import te from "../../_mixins/use-config.js";
import ne from "../../_mixins/use-form-item.js";
import oe from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-merged-state.js";
import A from "../../_mixins/use-theme.js";
import { createTreeMate as le } from "../../../../../../treemate@0.3.11/node_modules/treemate/es/create.js";
import { useThemeClass as re } from "../../_mixins/use-css-vars-class.js";
import ie from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/life-cycle/use-is-mounted.js";
import { getFirstSlotVNodeWithTypedProps as ae } from "../../_utils/vue/get-first-slot-vnode.js";
import ue from "../../input/src/Input.js";
import se from "../../../../../../vdirs@0.1.8_vue@3.5.18/node_modules/vdirs/es/clickoutside.js";
import de from "../../_internal/select-menu/src/SelectMenu.js";
import { warnOnce as ce } from "../../_utils/naive/warn.js";
import me from "../styles/light.js";
import { getPreciseEventTarget as fe } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/dom/get-precise-event-target.js";
import { call as m } from "../../_utils/vue/call.js";
import { defineComponent as he, watchEffect as pe, computed as p, h as s, withDirectives as ve } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as f, toRef as ge } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { useAdjustedTo as R } from "../../_utils/composable/use-adjusted-to.js";
import be from "../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/binder/src/Binder.js";
import Se from "../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/binder/src/Target.js";
import Ce from "../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/binder/src/Follower.js";
import { Transition as Te } from "../../../../../../@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
const ye = Object.assign(Object.assign({}, A.props), {
  to: R.propTo,
  menuProps: Object,
  append: Boolean,
  bordered: {
    type: Boolean,
    default: void 0
  },
  clearable: {
    type: Boolean,
    default: void 0
  },
  defaultValue: {
    type: String,
    default: null
  },
  loading: {
    type: Boolean,
    default: void 0
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  placeholder: String,
  placement: {
    type: String,
    default: "bottom-start"
  },
  value: String,
  blurAfterSelect: Boolean,
  clearAfterSelect: Boolean,
  getShow: Function,
  showEmpty: Boolean,
  inputProps: Object,
  renderOption: Function,
  renderLabel: Function,
  size: String,
  options: {
    type: Array,
    default: () => []
  },
  zIndex: Number,
  status: String,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onSelect: [Function, Array],
  onBlur: [Function, Array],
  onFocus: [Function, Array],
  // deprecated
  onInput: [Function, Array]
}), Je = he({
  name: "AutoComplete",
  props: ye,
  slots: Object,
  setup(n) {
    process.env.NODE_ENV !== "production" && pe(() => {
      n.onInput !== void 0 && ce("auto-complete", "`on-input` is deprecated, please use `on-update:value` instead.");
    });
    const {
      mergedBorderedRef: a,
      namespaceRef: l,
      mergedClsPrefixRef: i,
      inlineThemeDisabled: o
    } = te(n), h = ne(n), {
      mergedSizeRef: _,
      mergedDisabledRef: x,
      mergedStatusRef: M
    } = h, C = f(null), v = f(null), T = f(n.defaultValue), E = ge(n, "value"), g = oe(E, T), d = f(!1), y = f(!1), I = A("AutoComplete", "-auto-complete", Z, me, n, i), w = p(() => ee(n.options)), P = p(() => {
      const {
        getShow: e
      } = n;
      return e ? e(g.value || "") : !!g.value;
    }), z = p(() => P.value && d.value && (n.showEmpty ? !0 : !!w.value.length)), D = p(() => le(w.value, Y("value", "children")));
    function b(e) {
      const {
        "onUpdate:value": t,
        onUpdateValue: r,
        onInput: u
      } = n, {
        nTriggerFormInput: S,
        nTriggerFormChange: X
      } = h;
      r && m(r, e), t && m(t, e), u && m(u, e), T.value = e, S(), X();
    }
    function N(e) {
      const {
        onSelect: t
      } = n, {
        nTriggerFormInput: r,
        nTriggerFormChange: u
      } = h;
      t && m(t, e), r(), u();
    }
    function j(e) {
      const {
        onBlur: t
      } = n, {
        nTriggerFormBlur: r
      } = h;
      t && m(t, e), r();
    }
    function k(e) {
      const {
        onFocus: t
      } = n, {
        nTriggerFormFocus: r
      } = h;
      t && m(t, e), r();
    }
    function U() {
      y.value = !0;
    }
    function $() {
      window.setTimeout(() => {
        y.value = !1;
      }, 0);
    }
    function L(e) {
      var t, r, u;
      switch (e.key) {
        case "Enter":
          if (!y.value) {
            const S = (t = v.value) === null || t === void 0 ? void 0 : t.getPendingTmNode();
            S && (B(S.rawNode), e.preventDefault());
          }
          break;
        case "ArrowDown":
          (r = v.value) === null || r === void 0 || r.next();
          break;
        case "ArrowUp":
          (u = v.value) === null || u === void 0 || u.prev();
          break;
      }
    }
    function B(e) {
      (e == null ? void 0 : e.value) !== void 0 && (N(e.value), n.clearAfterSelect ? b(null) : e.label !== void 0 && b(n.append ? `${g.value}${e.label}` : e.label), d.value = !1, n.blurAfterSelect && Q());
    }
    function K() {
      b(null);
    }
    function H(e) {
      d.value = !0, k(e);
    }
    function W(e) {
      d.value = !1, j(e);
    }
    function q(e) {
      d.value = !0, b(e);
    }
    function G(e) {
      B(e.rawNode);
    }
    function J(e) {
      var t;
      !((t = C.value) === null || t === void 0) && t.contains(fe(e)) || (d.value = !1);
    }
    function Q() {
      var e, t;
      !((e = C.value) === null || e === void 0) && e.contains(document.activeElement) && ((t = document.activeElement) === null || t === void 0 || t.blur());
    }
    const O = p(() => {
      const {
        common: {
          cubicBezierEaseInOut: e
        },
        self: {
          menuBoxShadow: t
        }
      } = I.value;
      return {
        "--n-menu-box-shadow": t,
        "--n-bezier": e
      };
    }), c = o ? re("auto-complete", void 0, O, n) : void 0, F = f(null), V = {
      focus: () => {
        var e;
        (e = F.value) === null || e === void 0 || e.focus();
      },
      blur: () => {
        var e;
        (e = F.value) === null || e === void 0 || e.blur();
      }
    };
    return {
      focus: V.focus,
      blur: V.blur,
      inputInstRef: F,
      uncontrolledValue: T,
      mergedValue: g,
      isMounted: ie(),
      adjustedTo: R(n),
      menuInstRef: v,
      triggerElRef: C,
      treeMate: D,
      mergedSize: _,
      mergedDisabled: x,
      active: z,
      mergedStatus: M,
      handleClear: K,
      handleFocus: H,
      handleBlur: W,
      handleInput: q,
      handleToggle: G,
      handleClickOutsideMenu: J,
      handleCompositionStart: U,
      handleCompositionEnd: $,
      handleKeyDown: L,
      mergedTheme: I,
      cssVars: o ? void 0 : O,
      themeClass: c == null ? void 0 : c.themeClass,
      onRender: c == null ? void 0 : c.onRender,
      mergedBordered: a,
      namespace: l,
      mergedClsPrefix: i
    };
  },
  render() {
    const {
      mergedClsPrefix: n
    } = this;
    return s("div", {
      class: `${n}-auto-complete`,
      ref: "triggerElRef",
      onKeydown: this.handleKeyDown,
      onCompositionstart: this.handleCompositionStart,
      onCompositionend: this.handleCompositionEnd
    }, s(be, null, {
      default: () => [s(Se, null, {
        default: () => {
          const a = this.$slots.default;
          if (a)
            return ae("default", a, {
              handleInput: this.handleInput,
              handleFocus: this.handleFocus,
              handleBlur: this.handleBlur,
              value: this.mergedValue
            });
          const {
            mergedTheme: l
          } = this;
          return s(ue, {
            ref: "inputInstRef",
            status: this.mergedStatus,
            theme: l.peers.Input,
            themeOverrides: l.peerOverrides.Input,
            bordered: this.mergedBordered,
            value: this.mergedValue,
            placeholder: this.placeholder,
            size: this.mergedSize,
            disabled: this.mergedDisabled,
            clearable: this.clearable,
            loading: this.loading,
            inputProps: this.inputProps,
            onClear: this.handleClear,
            onFocus: this.handleFocus,
            onUpdateValue: this.handleInput,
            onBlur: this.handleBlur
          }, {
            suffix: () => {
              var i, o;
              return (o = (i = this.$slots).suffix) === null || o === void 0 ? void 0 : o.call(i);
            },
            prefix: () => {
              var i, o;
              return (o = (i = this.$slots).prefix) === null || o === void 0 ? void 0 : o.call(i);
            }
          });
        }
      }), s(Ce, {
        show: this.active,
        to: this.adjustedTo,
        containerClass: this.namespace,
        zIndex: this.zIndex,
        teleportDisabled: this.adjustedTo === R.tdkey,
        placement: this.placement,
        width: "target"
      }, {
        default: () => s(Te, {
          name: "fade-in-scale-up-transition",
          appear: this.isMounted
        }, {
          default: () => {
            var a;
            if ((a = this.onRender) === null || a === void 0 || a.call(this), !this.active)
              return null;
            const {
              menuProps: l
            } = this;
            return ve(s(de, Object.assign({}, l, {
              clsPrefix: n,
              ref: "menuInstRef",
              theme: this.mergedTheme.peers.InternalSelectMenu,
              themeOverrides: this.mergedTheme.peerOverrides.InternalSelectMenu,
              "auto-pending": !0,
              class: [`${n}-auto-complete-menu`, this.themeClass, l == null ? void 0 : l.class],
              style: [l == null ? void 0 : l.style, this.cssVars],
              treeMate: this.treeMate,
              multiple: !1,
              renderLabel: this.renderLabel,
              renderOption: this.renderOption,
              size: "medium",
              onToggle: this.handleToggle
            }), {
              empty: () => {
                var i, o;
                return (o = (i = this.$slots).empty) === null || o === void 0 ? void 0 : o.call(i);
              }
            }), [[se, this.handleClickOutsideMenu, void 0, {
              capture: !0
            }]]);
          }
        })
      })]
    }));
  }
});
export {
  ye as autoCompleteProps,
  Je as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/auto-complete/src/AutoComplete.js
// module id = 904
// module chunks = 41